@if (!emptyTpl() || items()?.length) {
    <div [class.tt-nochildren]="noEditToggle() || !showEdits()">
        @if (!noHeader()) {
            @let canEdit = (projectId() && canEditProj()) || ((!projectId() || showOrgTags()) && canEditOrg());
            <div class="layout flex center bg mb05 ph05 pv025 mr05 gap05">
                @if (canEdit && !noCreateButton() && showEdits()) {

                    <button class="vz-ok-btn"
                        nz-button
                        [class.ant-btn-icon-only]="_mobile()"
                        nzType="primary"
                        (click)="editTag()">
                        <i class="vzi-plus"></i>
                        @if (!_mobile()) {
                            <span>Создать тег</span>
                        }
                    </button>
                }
                <div class="layout flex" [style.max-width.px]="_mobile() ? null : 800">
                    <nz-input-wrapper [class.ant-group-hl]="!!fText()">
                        <i nzInputPrefix class="vzi-search fs-xl ml-025"></i>
                        <input
                            nz-input
                            type="text"
                            [(ngModel)]="fText"
                            (ngModelChange)="search.next($event)"
                            placeholder="Поиск..."
                            [aFocus]="noAutofocus() ? -1 : 500"
                        />
                        @if (fText()) {
                            <i nzInputSuffix class="vzi-close fs-xs txt-l c-p" (click)="fText.set(''); search.next('')"></i>
                        }
                    </nz-input-wrapper>
                </div>
                @if (canEdit && !noEditToggle()) {
                    @if (_mobile()) {
                        <button class="ant-btn-icon-only" nz-button [nzType]="showEdits() ? 'primary' : 'default'" (click)="showEdits.set(!showEdits())">
                            <i class="vzi-edit"></i>
                        </button>
                    }
                    @else {
                        <nz-switch class="ml05" [(ngModel)]="showEdits"></nz-switch>
                        <span class="c-p" (click)="showEdits.set(!showEdits())">Редактировать</span>
                    }
                }
            </div>
        }
        <div class="layout vertical flex relative">
            @let tagsSearch = searchItems();
            @let tags = items();
            @if(tags || tagsSearch) {
                @if (tagsSearch) {
                    @if (tagsSearch.length) {
                        <div class="w100 scroll-y"
                            dm-tree
                            dmTreeAsync="true"
                            [dmTreeItems]="tagsSearch"
                            [dmTreeLoadChildrenFn]="loadChildren"
                            [dmTreeWrapperClassesFn]="isChecked"
                            [dmTreeLevelLimit]="31"
                            [dmTreeFoldTooltip]="!noEditToggle() && showEdits() ? 'Разверните чтобы добавить вложенный тег' : ''"
                            (dmTreeItemClick)="tagClick($event.item)">
                            <ng-template let-tag let-ptag="parent" #itemTpl>
                                <ng-container [ngTemplateOutlet]="itemTagTpl" [ngTemplateOutletContext]="{ $implicit: tag, ptag}" />
                            </ng-template>
                            <ng-template let-tag #childrenFooterTpl>
                                @let canEdit = (tag.projectId && canEditProj()) || (!tag.projectId && canEditOrg());
                                @if (!noEditToggle() && showEdits()) {
                                    @if (canEdit) {
                                        <a class="ph025" (click)="editTag(tag, true)">+ добавить тег</a>
                                    }
                                    @else if (!tag?.children?.length) {
                                        <span class="txt-ll fs-s">нет вложенных тегов</span>
                                    }
                                }
                            </ng-template>
                        </div>
                    }
                    @else {
                        <span class="txt-pl op08 fs-s pv025 ph05">Теги не найдены.</span>
                    }
                }
                <div class="w100 scroll-y"
                    [class.hidden]="tagsSearch"
                    dm-tree
                    dmTreeAsync="true"
                    [dmTreeItems]="tags"
                    [dmTreeLoadChildrenFn]="loadChildren"
                    [dmTreeWrapperClassesFn]="isChecked"
                    [dmTreeLevelLimit]="31"
                    [dmTreeFoldTooltip]="!noEditToggle() && showEdits() ? 'Разверните чтобы добавить вложенный тег' : ''"
                    (dmTreeItemClick)="tagClick($event.item)">
                    <ng-template let-tag let-ptag="parent" #itemTpl>
                        <ng-container [ngTemplateOutlet]="itemTagTpl" [ngTemplateOutletContext]="{ $implicit: tag, ptag}" />
                    </ng-template>
                    <ng-template let-tag #childrenFooterTpl>
                        @let canEdit = (tag.projectId && canEditProj()) || (!tag.projectId && canEditOrg());
                        @if (!noEditToggle() && showEdits()) {
                            @if (canEdit) {
                                <a class="ph025" (click)="editTag(tag, true)">+ добавить тег</a>
                            }
                            @else if (!tag?.children?.length) {
                                <span class="txt-ll fs-s">нет вложенных тегов</span>
                            }
                        }
                    </ng-template>
                </div>

                <ng-template let-tag let-ptag="parent" #itemTagTpl>
                    @let canEdit = (tag.projectId && canEditProj()) || (!tag.projectId && canEditOrg());
                    @let dg = disabledGroups();
                    @let disabled = !checked[tag.id] && dg && (dg[tag.id] || (tag.parentId && dg[tag.parentId]));
                    <div class="layout center gap025">
                        @if (mode() == 'multiselect') {
                            <label
                                [class.op06]="disabled"
                                [class.ant-checkbox-warn]="tag.uniqueGroup || ptag?.uniqueGroup"
                                nz-checkbox
                                [(ngModel)]="checked[tag.id]"
                                [nzDisabled]="disabled"
                                (ngModelChange)="updateSelected(); updateDisabledGroups();">
                            </label>
                        }
                        <vz-tag [class.op06]="disabled" [tagId]="tag.id" />
                        @if (tag.projectId && (showAllProjects() || showOrgTags())) {
                            <vz-project-badge class="top-1" [class.op04]="disabled" [class.op08]="!disabled" [guid]="tag.projectId" />
                        }
                        @if (canEdit && !noEditToggle() && showEdits() && !_mobile()) {
                            <!-- @if (mode() != 'normal') {
                                <i class="vzi-edit txt-l vz-btn-xs" (click)="se($event); editTag(tag)"></i>
                            } -->
                            <i class="vzi-plus txt-ok vz-btn-xs"
                                (click)="se($event); editTag(tag, true);">
                            </i>
                            <i class="vzi-edit txt-l vz-btn-xs" (click)="se($event); editTag(tag)"></i>
                            <i class="vzi-trash-o txt-err vz-btn-xs" #pc="nzPopconfirm"
                                nz-popconfirm
                                nzPopconfirmTitle="Уверены? Будут также удалены все вложенные теги если они есть."
                                [nzPopconfirmTrigger]="null"
                                (click)="se($event); pc.show();"
                                (nzOnConfirm)="pc.hide(); deleteItem(tag.id);">
                            </i>
                        }
                        @if (tag.description) {
                            <div class="txt-l fs-s ph05 br8 bg bc b1dot ml1 elli" style="max-width: 800px" [class.op06]="disabled">{{ tag.description }}</div>
                        }
                    </div>
                </ng-template>
            }
            @else if (_error()) {
                <div class="layout flex center-center">
                    <vz-error-panel [error]="_error()" />
                </div>
            }
            @else {
                <div class="layout flex center-center"><div class="loader micro"></div></div>
            }
        </div>
    </div>

    @if (tag(); as etag) {
        @let ptag = pTag();
        <vz-tag-drawer
            [tagId]="etag.id"
            [parentId]="ptag?.id"
            [projectId]="etag.id ? etag.projectId : (ptag?.id ? ptag!.projectId : projectId())"
            [canChangeType]="!ptag && projectId() && canEditProj() && showOrgTags() && canEditOrg()"
            (closePanel)="closeTagDrawer($event)" />
    }
    @if (error) {
        <vz-error-message [error]="error" (dismiss)="error = undefined" />
    }
}
@else if (emptyTpl()) {
    <ng-container [ngTemplateOutlet]="emptyTpl()" />
}